import { endPoints } from "@/constants/apiSetting";
import httpClient from "@/common/service/HttpClient";
const DocumentTemplateService = {
  getAllDocTempList(obj) {
    return httpClient.post(endPoints.getAllDocTempList, obj);
  },
  getDocTempDetailByTypeAndTempCode(obj) {
    return httpClient.post(endPoints.getDocTempDetailByTypeAndTempCode, obj);
  },
  getDocTypes(obj) {
    return httpClient.post(endPoints.getDocTypes, obj);
  },
  getAllSysVar(obj) {
    return httpClient.post(endPoints.getAllSysVar, obj);
  },
  getAllDocTempListByType(obj) {
    return httpClient.post(endPoints.getAllDocTempListByType, obj);
  },
  addDocTemp(obj) {
    return httpClient.post(endPoints.addDocTemp, obj);
  },
  updateDocTemp(obj) {
    return httpClient.post(endPoints.updateDocTemp, obj);
  },
  deleteDocTemp(obj) {
    return httpClient.post(endPoints.deleteDocTemp, obj);
  },
};

export default DocumentTemplateService;



// WEBPACK FOOTER //
// ./src/service/DocumentTemplateService.js